import { updateDirectSalesCampaignGrid } from 'modules/api/directSalesCampaign';
import { ToasterTimeout, ToasterType } from 'lib/Toaster/Toaster.types';
import {
  DiscountLineGridAttributes,
  DirectSalesUpdatedCampaignNegotiationTypes,
} from 'components/common/types/DirectSalesCampaign.types';
import { CancelFunctions } from 'components/common/types';

export const updateGridNegotiationTypes = async (
  notificationCallback: (
    {
      header,
      description,
      type,
      timeout,
    }: { header: string; description?: string; type: ToasterType; timeout?: ToasterTimeout },
    unchangedKeys?: string[],
  ) => void,
  updatedGridNegotiationTypes: DirectSalesUpdatedCampaignNegotiationTypes,
  campaignId: string,
  marketId: string,
  cancelFunctions: CancelFunctions,
): Promise<void> => {
  try {
    const data = {
      discountLineKeyGridAttributes: updatedGridNegotiationTypes.reduce<Record<string, DiscountLineGridAttributes>>(
        (acc, { rowKey, negotiationType }) => {
          acc[rowKey] = { NEGOTIATION_TYPE: negotiationType };
          return acc;
        },
        {},
      ),
    };

    const { updatedKeys, unchangedKeys } = await updateDirectSalesCampaignGrid(
      data,
      campaignId,
      marketId,
      cancelFunctions,
    );

    if (updatedKeys.length) {
      notificationCallback({
        header: 'Grid changes have been saved',
        type: 'Success',
        timeout: 2000,
      });
    }

    if (unchangedKeys.length) {
      notificationCallback(
        {
          header: 'Grid changes cannot be updated',
          description: 'Highlighted rows could not be saved due to a failure',
          type: 'Failure',
        },
        unchangedKeys,
      );
    }
  } catch (e) {
    notificationCallback({
      header: 'All grid changes cannot be updated',
      type: 'Failure',
      timeout: 2000,
    });
  }
};
